import React, { FC, Suspense, lazy } from 'react'
import { Route, Routes as RoutesWrap, Navigate } from 'react-router-dom'
import { isFeatureEnabled, FeatureFlag } from './utils/featureFlags'

// Lazy load all page components for code splitting
const BuyCrypto = lazy(() => import('./pages/BuyCrypto'))
const SellCrypto = lazy(() => import('./pages/SellCrypto'))
const UserProfile = lazy(() => import('./pages/UserProfile'))
const UpdatePassword = lazy(() => import('./pages/UpdatePassword'))
const TradeHistory = lazy(() => import('./pages/TradeHistory'))
const SuitTest = lazy(() => import('./pages/SuitTest'))
const KnowledgeTest = lazy(() => import('./pages/KnowledgeTest'))
const KYC = lazy(() => import('./pages/KYC'))
const Terms = lazy(() => import('./pages/TermsOfServices'))
const Fees = lazy(() => import('./pages/Fees'))

// Loading fallback component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
  </div>
)

export const Router: FC = () => {
  const isSellCryptoEnabled = isFeatureEnabled(FeatureFlag.SELL_CRYPTO)

  function RedirectPathToSwapOnly() {
    return <Navigate to="/buy" replace={true} />
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <RoutesWrap>
        <Route path="/buy" element={<BuyCrypto />} />
        {isSellCryptoEnabled && <Route path="/sell" element={<SellCrypto />} />}
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/trade-history" element={<TradeHistory />} />
        <Route path="/suitability-test/*" element={<SuitTest />} />
        <Route path="/knowledge-test/*" element={<KnowledgeTest />} />
        <Route path="/kyc/*" element={<KYC />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/fees" element={<Fees />} />
        <Route path="*" element={<RedirectPathToSwapOnly />} />
      </RoutesWrap>
    </Suspense>
  )
}
